import { render, staticRenderFns } from "./EnviarRecetaPedidoWA.vue?vue&type=template&id=cb72e2d8&scoped=true"
import script from "./EnviarRecetaPedidoWA.vue?vue&type=script&lang=js"
export * from "./EnviarRecetaPedidoWA.vue?vue&type=script&lang=js"
import style0 from "./EnviarRecetaPedidoWA.vue?vue&type=style&index=0&id=cb72e2d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb72e2d8",
  null
  
)

export default component.exports